import {Injectable, ElementRef} from '@angular/core'
import { NgForm } from '@angular/forms';
import * as moment from 'moment';

declare var $: any;
declare let mApp: any;

@Injectable()
export class ClientSideUtility {
    
    applyToolTips(): void {
     
        (<any>mApp).initTooltips();
    }

    destroyTooltip(): void{
        $('.m-tooltip').tooltip('dispose');
    }

    applyPortlets():void{

        (<any>mApp).initPortlets();
    }

    showFileName(fileName: string): void {        
        $('.custom-file-label').html(fileName);
    }

    hideFileName(): void {        
        $('.fileInput').val('');
    }
    
    startSpinner(): void {
       mApp.block($(window), {
        type: 'loader',
        state: 'primary',
        message: 'Please wait...'  
        });
    }

    toggleEnvironment(): void{

        let selector = $('#m_aside_left_minimize_toggle');
        selector.on('click', function(){
            if($(this).hasClass('m-brand__toggler--active')){
                $('.environment').hide();
            }
            else
            {
                $('.environment').show();
            }
        });        
    }

    minimizeLeftAside(): void{    
        $(document).ready(function(){          
            $('body').addClass('m-brand--minimize');
            $('body').addClass('m-aside-left--minimize');
            $('#m_aside_left_minimize_toggle').addClass('m-brand__toggler--active');
            $('#m_aside_left_minimize_toggle').click();        
        });
    }

    maximizeLeftAside(): void{     
        $(document).ready(function(){
            $('#m_aside_left_minimize_toggle').removeClass('m-brand__toggler--active');        
        });
    }

    setLeftAsideToggle(): void {
        $('#m_aside_left_minimize_toggle').click();
    }

    stopSpinner(): void{        
        mApp.unblock($(window));
    }

    addSpinnerToButton(): void {

        $('.addSpinner').addClass('m-btn--custom m-loader m-loader--light m-loader--left');
    }

    removeSpinnerFromButton(): void {

        $('.addSpinner').removeClass('m-btn--custom m-loader m-loader--light m-loader--left');
    }

    showAlertSuccess(title: string, message: string): void{               
        
        $.notify(`<h4>${title}</h4><p>${message}</p>`, { 
            type: 'success',
            allow_dismiss: true,
            newest_on_top: false,
            mouse_over:  true,            
            animate: {
                enter: 'animated bounceInDown',
                exit: 'animated bounceInDown'
            },
            timer: 4000,
            container: 'floating'
        });                
    }

    showAlertError(title: string, message: string): void {

        $.notify(`<h4>${title}</h4><p>${message}</p>`, { 
            type: 'danger',
            allow_dismiss: true,
            newest_on_top: false,
            mouse_over:  true,            
            animate: {
                enter: 'animated bounceInDown',
                exit: 'animated bounceInDown'
            },
            timer: 5000,
            container: 'floating'
        });
    }

    showAlertInformation(title: string, message: string): void{               
        
        $.notify(`<h4>${title}</h4><p>${message}</p>`, { 
            type: 'info',
            allow_dismiss: true,
            newest_on_top: false,
            mouse_over:  true,            
            animate: {
                enter: 'animated bounceInDown',
                exit: 'animated bounceInDown'
            },
            timer: 5000,
            container: 'floating'
        });                
    }

    toggleModal(modalId, show:boolean){
        $("#" + modalId).modal(show ? 'show' : 'hide');
    }    

    collapseAccordian(className: string){
        $("." + className).collapse('show');
    }   

    triggerEntityIdValidation(form: NgForm){

        form.controls['enityId'].markAsDirty();        
    }   

    applyDatePickerRange(fromID: string, toID: string, startDate: string = ""): void {
          
        let selectorFrom: string = '';
        let selectorTo: string = '';

        selectorFrom = (" #" + fromID).trim();
        selectorTo = (" #" + toID).trim();

        selectorFrom = (" #" + fromID).trim();
        selectorTo = (" #" + toID).trim();

        let fromJQ = $(selectorFrom);
        let toJQ = $(selectorTo);

        if (fromJQ.attr('data-plugin-applied') == 1)
            return;

        if (toJQ.attr('data-plugin-applied') == 1)
            return;

        fromJQ.datepicker({
            todayHighlight: true,
            endDate: '+0d',
            format: 'mm/dd/yyyy',
            changeMonth: true,
            prevText: '<i class="fa fa-chevron-left"></i>',
            nextText: '<i class="fa fa-chevron-right"></i>',
            startDate: startDate == '' ? '01-01-1900' : startDate,
            onClose: function (selectedDate: any) {
            }
        })

        .on('changeDate', function (ev){
            
            let startDate = fromJQ.val();      
            if(startDate!=''){      
                toJQ.datepicker('setStartDate', startDate);
            }

            const customEvent = document.createEvent('Event');
            customEvent.initEvent('blur', true, true);
            fromJQ[0].dispatchEvent(customEvent);            
        })
        .on('clearDate', function(){            
            toJQ.datepicker('setStartDate', '1/1/1900');
        });

        toJQ.datepicker({
            todayHighlight: true,
            endDate: '+0d',
            format: 'mm/dd/yyyy',
            changeMonth: true,
            prevText: '<i class="fa fa-chevron-left"></i>',
            nextText: '<i class="fa fa-chevron-right"></i>',
            onClose: function (selectedDate: any) {
            }
        }).on('changeDate', function (ev) {
            let endDate = toJQ.val();
            fromJQ.datepicker('setEndDate', endDate);

            const customEvent = document.createEvent('Event');
            
            customEvent.initEvent('blur', true, true);
            toJQ[0].dispatchEvent(customEvent);
        })
        .on('clearDate', function(){
            var today = new Date();
            fromJQ.datepicker('setEndDate', today);
        });

        fromJQ.attr('data-plugin-applied', 1);
        toJQ.attr('data-plugin-applied', 1);
    }

    setDate(id:string, date:string){
        
        let controlId = (" #" + id).trim();        
        let selecter =  $(controlId);
        selecter.val(date);
    }

    resetCalender(id:string): void{

        let controlId = (" #" + id).trim();   
        let selecter =  $(controlId);
        selecter.datepicker('update', '');
    }

    resizeLeftSideNavigation(){
        var height = $('body').height() - 70;      
        $(".m-aside-left").css('min-height', height + 'px');        
    }

    resizeCurrentRequestsArea(){
        var height = $('body').height() - 225;      
        $(".currentRequests").css('min-height', height + 'px');        
    }

    delay(seconds: number):void {
        let waitUntil = new Date(new Date().getTime() + seconds * 1000);
        while(waitUntil > new Date()){           
        }
    }

    redirect(url: string): void{
        window.location.href = url;
    }

    isValidEntityID(entityID:string): boolean{
        if(entityID == null || entityID == "" )
            return false;

        return entityID.length == 7;
    }

    clearAllSelection() {
        window.getSelection().removeAllRanges();
    }

    datePickerValue(id: string): string {
        return $('#' + id).val();
    }

    applyDatePickerRangeWithOptions(fromID: string, toID: string, containerID?: string, fromOptions?: Array<IDatePickerOptions>, toOptions?: Array<IDatePickerOptions>): void {

        let datePicker: any;
        let selector: string = '';
        let selectorFrom: string = '';
        let selectorTo: string = '';

        if (containerID)
            selector = "#" + containerID;

        selectorFrom = (selector + " #" + fromID).trim();
        selectorTo = (selector + " #" + toID).trim();

        if (containerID)
            selector = "#" + containerID;

        selectorFrom = (selector + " #" + fromID).trim();
        selectorTo = (selector + " #" + toID).trim();

        let fromJQ = $(selectorFrom);
        let toJQ = $(selectorTo);

        if (fromJQ.attr('data-plugin-applied') == 1)
            return;

        if (toJQ.attr('data-plugin-applied') == 1)
            return;

        fromJQ.datepicker({
            defaultDate: "+1w",
            dateFormat: 'mm/dd/yy',
            changeMonth: true,
            numberOfMonths: 2,
            prevText: '<i class="fa fa-chevron-left"></i>',
            nextText: '<i class="fa fa-chevron-right"></i>',
            onClose: function (selectedDate: any) {
                $(selectorTo).datepicker("option", "minDate", selectedDate);
            },
            onSelect: function (selectedDate: any) {
                const customEvent = document.createEvent('Event');
                customEvent.initEvent('change', true, true);
                fromJQ[0].dispatchEvent(customEvent);
            }

        });
        toJQ.datepicker({
            defaultDate: "+1w",
            dateFormat: 'mm/dd/yy',
            changeMonth: true,
            numberOfMonths: 2,
            prevText: '<i class="fa fa-chevron-left"></i>',
            nextText: '<i class="fa fa-chevron-right"></i>',
            onClose: function (selectedDate: any) {
                $(selectorFrom).datepicker("option", "maxDate", selectedDate);
            },
            onSelect: function (selectedDate: any) {
                const customEvent = document.createEvent('Event');
                customEvent.initEvent('change', true, true);
                toJQ[0].dispatchEvent(customEvent);
            }
        });

        if (fromOptions && fromOptions.length > 0) {
            for (let i = 0; i < fromOptions.length; i++) {
                fromJQ.datepicker("option", fromOptions[i].key, fromOptions[i].value);
            }
        }

        if (toOptions && toOptions.length > 0) {
            for (let i = 0; i < toOptions.length; i++) {
                toJQ.datepicker("option", toOptions[i].key, toOptions[i].value);
            }
        }

        fromJQ.attr('data-plugin-applied', 1);
        toJQ.attr('data-plugin-applied', 1);

    }
}
export interface IDatePickerOptions {
    key: string,
    value: any
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/Shared/service/ClientSideUtility.ts